import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      stroke: "#464646",
      "stroke-width": ".5",
      d: "M2 11.615c0 .359.277.635.637.635a.6.6 0 0 0 .45-.193l5.486-5.344a.64.64 0 0 0 .007-.925L3.087.435A.66.66 0 0 0 2.63.25.62.62 0 0 0 2 .885c0 .173.062.332.187.449l5.479 5.337v-.85l-5.479 5.345a.62.62 0 0 0-.187.449Zm6.76.034c0 .352.256.601.617.601.36 0 .623-.249.623-.6V.864c0-.36-.263-.615-.623-.615a.59.59 0 0 0-.617.615z"
    }, null, -1)
  ])))
}
export default { render: render }